import { createContext, useState } from 'react';
import api from 'services/api';

export const RemessasContext = createContext();

export const RemessasProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);

  const getMaleta = async ({ cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Comercial/Remessas/Maleta`);
      cb?.(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <RemessasContext.Provider value={{ getLoading, getMaleta }}>
      {children}
    </RemessasContext.Provider>
  );
};
